$(function() {
  if ($('.homepage_slider')) {
    $(window).resize(function () {
      updateHeroHeight();
    });    
    
    // Call function when document is loaded
    updateHeroHeight();
  }

  function updateHeroHeight() {
    
    // save min size of hero
    $('.homepage_slider').css('min-height', '250px');
    
    // set position of the back image
    $('.homepage_slider .bcg.background_image').css('top', 0);
    
    // get size of header
    //var heightNav = 0;
    var heightNav = $('.header').height();        
    
    // set the height of the hero
    $('.homepage_slider').css('height', $(window).height() - heightNav - $('.featured_collections.slider').height() - 70);    
    
	// test the size of the website to change the max height
    //if ($(window).width() > 480) {
      //$('.homepage_slider').css('max-height', $(window).height() - heightNav - $('.featured_collections.slider').height() - 70);
    //} else {
      //$('.homepage_slider').css('max-height', '390px');
    //}

    // set the height of the back image to same the hero div
    if ($('.homepage_slider').height() > $('.homepage_slider .bcg.background_image').height()) {
      $('.homepage_slider .bcg.background_image').height($('.homepage_slider').height());
      $('.homepage_slider .bcg.background_image').width('auto');
    }	
    
    
    //$('#explore-categories').append('TEST IF FUNTION IS RUNNING')
    
  } 
});


